import React, { useState } from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import { formatCurrency } from '@wolffun/system-currency';
import { chainIconMap } from 'src/Pages/ProjectDetailPage/Components/ProjectPanel/config';
import { formatTimestamp } from 'src/Pages/Staking/utils';
import { navigateToProjectDetail } from 'src/utils/navigate';
import IntervalTicker from 'src/utils/intervalTicker';

const ProjectCard = ({
  project
}) => {
  const chainIcon = chainIconMap[project.chainName];
  const [remainingTime, setRemainingTime] = useState(0);
  React.useEffect(() => {
    if (!project.closeAt) {
      return () => {};
    }

    const intervalTicket = new IntervalTicker(Date.now(), project.closeAt, timestamp => {
      setRemainingTime(timestamp);
    }, () => {});
    intervalTicket.start();
    return () => {
      intervalTicket.clear();
    };
  }, [project.closeAt]);

  const renderNumber = time => {
    return time.toLocaleString('en-US', {
      minimumIntegerDigits: 2,
      useGrouping: false
    });
  };

  const renderRemainingTime = () => {
    if (project.closeAt) {
      const time = formatTimestamp(remainingTime);
      return /*#__PURE__*/React.createElement("div", {
        className: styles.time
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.label
      }, "Application close in"), /*#__PURE__*/React.createElement("span", {
        className: styles.countdown
      }, `
              ${renderNumber(time.days)}d
              ${renderNumber(time.hours)}h
              ${renderNumber(time.minutes)}m
            `));
    }

    return null;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.card,
    onClick: () => navigateToProjectDetail(project.id)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardMedia
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.img,
    src: project.imageUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.status, styles[project.allowlistStatus])
  }, /*#__PURE__*/React.createElement("span", null, "Allowlist ", project.allowlistStatus)), /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.logo,
    src: project.logoUrl
  }), renderRemainingTime())), /*#__PURE__*/React.createElement("div", {
    className: styles.cardContent
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, project.name), /*#__PURE__*/React.createElement("img", {
    className: styles.icToken,
    src: chainIcon
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles.symbol
  }, project.symbol ? project.symbol : 'TBA')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Private Sale Pool")), /*#__PURE__*/React.createElement("div", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, `$${formatCurrency(project.totalSale, {
    trimWholeFraction: true
  })}`))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Personal Allocation")), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, `$${formatCurrency(project.maxAllocation, {
    withCurrency: false,
    trimWholeFraction: true
  })} Max`))));
};

export default ProjectCard;